type LoyaltyActionRewardProgressKind = 'one_time' | 'capped' | 'unlimited'

interface LoyaltyActionRewardProgress {
  kind: LoyaltyActionRewardProgressKind
  appliedCount: number
  /** one_time: 1; capped: maxRepeat; unlimited: milestone step (provisional 1) */
  target: number
  isFullyComplete: boolean
  /** 0–100 for status ring; unlimited static idle = 0 */
  percent: number
}

export default function getLoyaltyActionRewardProgress(input: {
  allowRepeat: boolean
  maxRepeat?: number
  appliedRecords: { length: number }
}): LoyaltyActionRewardProgress {
  const appliedCount = input.appliedRecords.length
  const { allowRepeat, maxRepeat } = input

  let kind: LoyaltyActionRewardProgressKind
  if (!allowRepeat) {
    kind = 'one_time'
  } else if (maxRepeat === undefined) {
    kind = 'unlimited'
  } else if (maxRepeat >= 1) {
    kind = 'capped'
  } else {
    // Non-positive caps are dropped from Quests; do not treat them as unlimited.
    kind = 'one_time'
  }

  switch (kind) {
    case 'one_time':
      return {
        kind,
        appliedCount,
        target: 1,
        isFullyComplete: appliedCount >= 1,
        percent: appliedCount >= 1 ? 100 : 0,
      }
    case 'capped': {
      const target = input.maxRepeat!

      return {
        kind,
        appliedCount,
        target,
        isFullyComplete: appliedCount >= target,
        percent: appliedCount >= target ? 100 : Math.round((appliedCount / target) * 100),
      }
    }
    case 'unlimited':
      return {
        kind,
        appliedCount,
        target: 1,
        isFullyComplete: false,
        percent: appliedCount > 0 ? 100 : 0,
      }
  }
}
